import { render, staticRenderFns } from "./MaintenanceComponent.vue?vue&type=template&id=0832bb20"
import script from "./MaintenanceComponent.vue?vue&type=script&lang=js"
export * from "./MaintenanceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports